import React__default from 'react';
import { ScrollIntoView, Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import PasswordForm from '../../components/PasswordForm/PasswordForm.js';

const SetPassword = ({ labels , consentItems , onSubmit , hasErrors , passwordlessErrorMessage , isLoading  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: "create-account myaccount__section"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "medium",
        component: "h1",
        className: "create-account__title"
    }, labels.title), /*#__PURE__*/ React__default.createElement("p", {
        className: "create-account__text"
    }, labels.text), Boolean(passwordlessErrorMessage) && /*#__PURE__*/ React__default.createElement(ScrollIntoView, {
        key: "passwordless-error"
    }, /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        message: passwordlessErrorMessage
    })), hasErrors && /*#__PURE__*/ React__default.createElement(ScrollIntoView, {
        key: "default-error"
    }, /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        message: labels.error
    })), /*#__PURE__*/ React__default.createElement(PasswordForm, {
        "data-t": "create-account-form",
        passwordLabel: labels.form.password,
        buttonCaption: labels.form.submit,
        onSubmit: onSubmit,
        isLoading: isLoading
    }, consentItems))
;
var SetPassword$1 = SetPassword;

export { SetPassword, SetPassword$1 as default };
//# sourceMappingURL=SetPassword.js.map
